module.exports = __webpack_public_path__ + "img/1.bb48f47f.jpg";